import { Contract as IContract, Project as IProject, IActor } from '@types';

import * as moment from 'moment';

export class ContractModel implements IContract {
    id: number;
    number: string;
    date: string;
    sent: string;
    poslana_na_email: string;
    date_m: moment.Moment;
    project: IProject;
    actor: IActor;
    text: string;

    constructor({ id, number, date, project, actor, text, sent, poslana_na_email }: IContract) {
        this.id = id;
        this.number = number;
        this.date = date;
        this.sent = sent;
        this.poslana_na_email = poslana_na_email;
        this.date_m = moment(date);
        this.project = project;
        this.actor = actor;
        this.text = text;
    }

    transform() {
        return {
            id: this.id,
            date: this.date_m.format('YYYY-MM-DD'),
            name: this.project.title,
            type: 'TV spot', //Hardcoded, nemame zatial info zo sluzby
            text: this.text,
        };
    }
}
